const LOCKED_CLASS_TARGETS = [
    "extension-button-container",
    "sprite-selector_add-button",
    "stage-selector_add-button",
    "sprite-selector-item_delete-button",
    "stage-selector_delete-button",
];

const LOCK_OBSERVER_KEY = "_roomLockObserver";

export const lockRoomUI = (workspace, { hideToolbox = true } = {}) => {
    if (workspace) {
        if (hideToolbox) {
            const toolbox = document.querySelector(
                '[class*="blocklyToolboxDiv"]',
            );
            if (toolbox) toolbox.style.display = "none";

            const flyout = workspace.getFlyout?.() || workspace.flyout_;
            if (flyout?.setContainerVisible) flyout.setContainerVisible(false);
        }

        workspace.options.readOnly = true;
    }

    hideByPartialClass("gui_extension-button-container");
    hideByPartialClass("react-tabs__tab-list");

    hideByPartialClass("sprite-selector_add-button");
    hideByPartialClass("stage-selector_add-button");

    hideByPartialClass("sprite-selector-item_delete-button");

    document
        .querySelectorAll(
            'input[class*="input_input-form"], input[class*="sprite-info"]',
        )
        .forEach((i) => {
            i.readOnly = true;
            i.disabled = true;
        });

    startLockObserver();
};

export const unlockRoomUI = (workspace) => {
    const observer = window[LOCK_OBSERVER_KEY];
    if (observer) {
        observer.disconnect();
        window[LOCK_OBSERVER_KEY] = null;
    }

    document.querySelectorAll('[data-_room-locked="true"]').forEach((el) => {
        el.style.display = "";
        delete el.dataset._roomLocked;
    });

    if (workspace) {
        const toolbox = document.querySelector('[class*="blocklyToolboxDiv"]');
        if (toolbox) toolbox.style.display = "";

        const flyout = workspace.getFlyout?.() || workspace.flyout_;
        if (flyout?.setContainerVisible) flyout.setContainerVisible(true);

        workspace.options.readOnly = false;
    }

    document
        .querySelectorAll(
            'input[class*="input_input-form"], input[class*="sprite-info"]',
        )
        .forEach((i) => {
            i.readOnly = false;
            i.disabled = false;
        });
};

const hideByPartialClass = (partialName) => {
    document.querySelectorAll(`[class*="${partialName}"]`).forEach((el) => {
        el.style.display = "none";
        el.dataset._roomLocked = "true";
    });
};

const startLockObserver = () => {
    if (window[LOCK_OBSERVER_KEY]) return;

    const selector = LOCKED_CLASS_TARGETS.map((t) => `[class*="${t}"]`).join(
        ", ",
    );

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType !== Node.ELEMENT_NODE) return;

                hideIfMatches(node);
                if (node.querySelectorAll)
                    node.querySelectorAll(selector).forEach(hideIfMatches);
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window[LOCK_OBSERVER_KEY] = observer;
};

const hideIfMatches = (el) => {
    const cls = el.className || "";
    if (typeof cls !== "string") return;

    if (LOCKED_CLASS_TARGETS.some((t) => cls.includes(t))) {
        el.style.display = "none";
        el.dataset._roomLocked = "true";
    }
};
